export default {
  uploadingLogo: 'Uploading logo',
  cancel: 'Cancel',
  modelSettings: 'Model settings:',
  save: 'Save',
  displayTab: 'Display',
  customNamesTab: 'Custom Names',
  metadataTab: 'Metadata',
  channelTaxonomyTab: 'Channel Taxonomy',
  channelTaxonomyChannels: 'Channels',
  channelTaxonomyNoChannels: 'This model has no media channels.',
  taxonomyLevelL0: 'Weight',
  taxonomyLevelL1: 'Strategy',
  taxonomyLevelL2: 'Definition',
  taxonomyLevelL3: 'Opening',
  taxonomyLevelL4: 'Format',
  taxonomyLevelL5: 'Vendor',
  taxonomyLevelL6: 'Custom',
  taxonomySelectParentFirst: 'Select {parent} first',
  metadataClient: 'Client',
  metadataBrand: 'Brand',
  metadataCategory: 'Category',
  metadataSubCategory: 'Sub-category',
  metadataCountry: 'Country',
  addValueTitle: 'Add new value',
  addValueButton: 'Add',
  addValueTooltip: 'Add a new value',
  addValueAbbreviationLabel: 'Abbreviation',
  addValueAbbreviationNoSpaces: 'The abbreviation cannot contain spaces',
  prettyMediaNames: 'Media Names',
  originalName: 'Original Name',
  displayName: 'Display Name',
  prettyComponentNames: 'Component Names',
  addPrettyComponentName: 'Add Pretty Component Name',
  delete: 'Delete',
  prettyExternalVariableNames: 'External Variable Names',
  addExternalVariableName: 'Add External Variable Name',
  primaryColor: 'Primary Color',
  primaryColorLabel: 'Primary Color (eg. #FF0000)',
  customKpiName: 'KPI Name (replaces "Sales")',
  customKpiNameLabel: 'Custom KPI Name',
  logo: 'Logo',
  hiddenKpis: 'Hidden KPIs',
  hiddenKpisLabel: 'KPIs to hide',
  hiddenKpisHint: 'Hidden KPIs are not shown to any user in the Model Report, plans, What-If or Compare Plans. While any KPI is hidden, the Total is hidden too.',
  hiddenKpisAtLeastOne: 'At least one KPI must remain visible',
  chooseLogoFile: 'Choose new logo file (PNG/JPG)',
  deleteLogo: 'Delete logo',
  required: 'Required',
  duplicatedMediaName: 'Duplicated media name',
  invalidPrimaryColor: 'Invalid Primary Color',
  errorUploadingLogo: 'Error uploading logo',
  componentNamesEmptyError: 'Component pretty names cannot have empty values',
  componentNamesDuplicateError: 'Component pretty names cannot have duplicate original names',
  externalVariablesEmptyError: 'External Variables pretty names cannot have empty values',
  externalVariablesDuplicateError: 'External Variables pretty names cannot have duplicate original names',
  errorUpdatingSettings: 'Error updating settings'
}
